// extracted by mini-css-extract-plugin
module.exports = {"hero":"hero_hero__3asoV","heroWraper":"hero_heroWraper__pEWJg","hrRght":"hero_hrRght__14Kas","hrLft":"hero_hrLft__14bXU","button":"hero_button__o_2Ih"};